import { CHANGE_JUMP, MAP_CHANGE, MAP_SAVE, MATERIAL_CHANGE, MATERIAL_FILTER_IMAGE, OPEN_LOGIN, REFRESH_LOGIN, REFRESH_STORYLINE, SAVE_MISSION, SAVE_MISSION_DETAIL, SAVE_SCENT, SAVE_SCENT_DETAIL } from '@/const/event';
import { MediaConfigType } from '@/const/richMedia';
import events from '@/hooks/useEventBus';
import { RichMediaValue } from '@/interface/media';
import { CgiErrorCode } from '@/services/cgi';

interface IMap {
  id: string;
}

interface IMaterial {
  key: string,
  url: string,
  type: MediaConfigType;
  resourceMaterialMaps?: { [key: string]: string }
}

interface IMaterialFilterImage {
  [key: string]: RichMediaValue | undefined
}

export const eventPool = {
  // 事件池
  eventsEmit: {
    saveScene: () => events.emit(SAVE_SCENT),
    saveSceneDetail: (payload: { id: string, code?: CgiErrorCode }) => events.emit(SAVE_SCENT_DETAIL, payload),
    saveMissionDetail: (payload: { id: string, code?: CgiErrorCode }) => events.emit(SAVE_MISSION_DETAIL, payload),
    saveMission: () => events.emit(SAVE_MISSION),
    mapChange: (payload?: {
      map: {
        id: string;
        info: IMap
      }
    }) => events.emit(MAP_CHANGE, payload),
    materialChange: (payload: IMaterial) => events.emit(MATERIAL_CHANGE, payload),
    materialFilterImage: (payload: IMaterialFilterImage) => events.emit(MATERIAL_FILTER_IMAGE, payload),
    mapSave: (payload: unknown) => events.emit(MAP_SAVE, payload),
    openLogin: () => events.emit(OPEN_LOGIN),
    refreshLogin: () => events.emit(REFRESH_LOGIN),
    refreshStoryline: () => events.emit(REFRESH_STORYLINE),
    changeJump: (payload: unknown) => events.emit(CHANGE_JUMP, payload),
  },

  eventsTypes: {
    SAVE_SCENT, // 保存场景
    SAVE_SCENT_DETAIL, // 保存场景详细信息
    MAP_CHANGE, // 画布
    MATERIAL_CHANGE, // 素材资源包
    MATERIAL_FILTER_IMAGE, // 滤镜
    OPEN_LOGIN, // 拉起登录框
    MAP_SAVE,
    REFRESH_LOGIN,
    REFRESH_STORYLINE,
    CHANGE_JUMP,
    SAVE_MISSION,
    SAVE_MISSION_DETAIL,
  },
};
